var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('el-footer',{staticClass:"footer"},[_vm._v("\n      "+_vm._s(_vm.$t('lang.footer.version'))+"\n      "),_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('lang.footer.owner')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be550ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 